module.exports = __webpack_public_path__ + "static/media/customersimulator.04d8c04f.svg";